import { useRecoilState } from 'recoil'
import { userState } from '../recoil/atoms'

export const useUser = () => {

  const [user, setUser] = useRecoilState(userState)

  const authenticating: boolean = user === undefined

  return {
    user,
    authenticating
  };
}
